import { CalendarClock } from 'lucide-react';

export function ShiftManagementPage() {
  return (
    <div className="p-6 max-w-7xl mx-auto" dir="rtl">
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <CalendarClock className="w-8 h-8 text-primary-600" />
          <h1 className="text-3xl font-bold text-gray-900">ניהול משמרות</h1>
        </div>
        <p className="text-gray-600">
          תכנון משמרות, סידור עבודה ומעקב נוכחות עובדים
        </p>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 p-8 text-center">
        <CalendarClock className="w-16 h-16 text-gray-400 mx-auto mb-4" />
        <h2 className="text-xl font-semibold text-gray-700 mb-2">
          בקרוב
        </h2>
        <p className="text-gray-600">
          מודול ניהול משמרות נמצא בפיתוח
        </p>
      </div>
    </div>
  );
}
